import { AutoMap } from "@automapper/classes"
import { EMilieuPrelevementAir } from "src/app/domain/Air/enum/milieu-prelevement"
import { PrelevementDTO } from "./prelevement.dto"
import { AppareilDTO } from "./appareil.dto"

export class PrelevementAirDTO {
    @AutoMap()
    code: string =  ''
    @AutoMap()
    tempsSedimentation?: number
    @AutoMap()
    volumeAirPreleve?: number
    @AutoMap()
    observations: string = ''
    @AutoMap()
    milieuPrelevement: EMilieuPrelevementAir = EMilieuPrelevementAir.PCA_SAB
    @AutoMap()
    lieuPrelevement?: number;
    @AutoMap()
    lieuPrelevementAutre: string = ''
    @AutoMap()
    methodePrelevementAir?: number;
    @AutoMap()
    prelevement: PrelevementDTO = new PrelevementDTO()
    @AutoMap()
    biocollecteur: AppareilDTO = new AppareilDTO()
}